import { render, staticRenderFns } from "./search-filter.vue?vue&type=template&id=3bc8dcba&scoped=true&"
import script from "./search-filter.vue?vue&type=script&lang=js&"
export * from "./search-filter.vue?vue&type=script&lang=js&"
import style0 from "./search-filter.vue?vue&type=style&index=0&id=3bc8dcba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc8dcba",
  null
  
)

export default component.exports